import { Component, OnInit, Input } from '@angular/core';
import { UserDetail } from 'lms-api';
import { LmsUserService } from 'lms-api';
import { ShoppingCartService } from 'lms-api';
import { LmsAppSettings } from 'lms-api';

@Component({
  selector: 'app-header-userinfo',
  templateUrl: './header-userinfo.component.html',
  styleUrls: ['./header-userinfo.component.scss']
})
export class HeaderUserinfoComponent implements OnInit {
  public user: UserDetail;
  public baseURL: string;
  constructor(private lmsUserService: LmsUserService, public cartService: ShoppingCartService, private LmsAppSettings: LmsAppSettings) { 
    this.lmsUserService.OnUserStateChange.subscribe(user => {
      this.user = user;
    })
  }

  ngOnInit() {
    this.baseURL = this.LmsAppSettings.siteBaseURL;
  }

  Logout() {
    this.lmsUserService.Logout();
    return false;
  }

}
